import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericFormGenComponent } from './generic-form-gen.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DotBounceLoadingEffectModule } from '../dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from '../input-with-autocomplete/input-with-autocomplete.module';
import { FormsModule } from '@angular/forms';
import { SquarePostLoadingEffectComponent } from '../square-post-loading-effect/square-post-loading-effect.component';

@NgModule({
	declarations: [GenericFormGenComponent],
	imports: [
		CommonModule,
		FormsModule,
		CheckboxModule,
		DotBounceLoadingEffectModule,
		FontAwesomeModule,
		InputWithAutocompleteModule,
		SquarePostLoadingEffectComponent,
	],
	exports: [GenericFormGenComponent],
})
export class GenericFormGenModule {}
